import styled, { css } from 'styled-components';

import Icon from '../../Icon';
import { focusState } from '../Form.style';

export default styled.span`
  display: inline-block;
`;

export const Input = styled.input.attrs({
  type: 'checkbox',
})`
  display: none;
`;

export const CheckIcon = styled(Icon)`
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0.25rem;
  color: ${({ theme }) => theme.COLOR_TEXT_BODY};
`;

export const CheckboxLabel = styled.label.attrs(props => ({
  tabIndex: 0,
}))`
  display: inline-block;
  flex: 0 0 1.5rem;
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid ${({ theme }) => theme.COLOR_GRAY};
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  user-select: none;
  cursor: pointer;

  ${({ customStyled }) => customStyled && css`${customStyled}`}

  background-color: ${({ theme, disabled }) => (disabled ? theme.COLOR_GRAY_LIGHTEST : theme.COLOR_WHITE)};
  ${focusState}

  ${({ theme }) => css`
    border-radius: 3px;
    border: 2px ${theme.COLOR_CYAN_DARK} solid;

    ${Input}:checked + & {
      background-color: ${theme.COLOR_CYAN_DARK};
      color: ${theme.COLOR_WHITE};

      & ${CheckIcon} {
        color: ${theme.COLOR_WHITE};
      }
    }
  `}

  ${({ errored, theme }) => errored && css`
    outline: none;
    border: none;
    border: 2px ${theme.COLOR_BERRY_RED} solid;
  `}

  ${({ disabled }) => disabled && css`
    opacity: 0.6;
    cursor: not-allowed;

    &:focus {
      box-shadow: none;
    }
  `}

  & svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    // per designs
    width: 16px;
    height: 12px;
  }
`;
